<template>
    <div>
        <b-container class="mt-5 mb-5">
            <h1 class="fs-4 font-weight-bold mb-4">Alle klanten</h1>

            <b-alert variant="info" show>
                <font-awesome-icon icon="fa-solid fa-info-circle" class="mr-1" />
                Hier vind je al je klanten terug die een bestelling hebben geplaatst bij één van je evenementen.
            </b-alert>

            <b-card no-body>

                <b-card-header>
                    <div class="float-sm-left">
                        Aantal gevonden: {{ totalRows }}
                    </div>
                    <div class="float-sm-right">

                    </div>
                </b-card-header>

                <!-- BODY -->
                <b-card-body>

                    <div v-if="customers.length <= 0" class="text-center text-muted mt-4 mb-4">
                        <font-awesome-icon icon="fa-solid fa-users" class="mb-2" size="2x" />
                        <div class="text-dark fs-5">Geen klanten gevonden</div>
                    </div>

                    <template v-else>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <td>#</td>
                                    <th>Voornaam</th>
                                    <th>Achternaam</th>
                                    <th>E-mail</th>
                                    <th>Ingeschreven op</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="customer in customers" :key="customer.id">
                                    <td>{{ customer.id }}</td>
                                    <td>{{ customer.firstname }}</td>
                                    <td>{{ customer.lastname }}</td>
                                    <td>{{ customer.email }}</td>
                                    <td>{{ customer.created_at.date | formatDateTime }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>

                </b-card-body>
                <b-card-footer>
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            Pagina {{ currentPage }} van {{ totalPages }}
                        </div>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            @change="onPageChange"
                        />

                    </div>
                </b-card-footer>
            </b-card>
        </b-container>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Alle klanten',
    },
    components: {},
    data() {
        return {
            customers: [],
            currentPage: 1,
            perPage: 15,
            totalRows: 0
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalRows / this.perPage);
        },
    },
    methods: {
        async getCustomers(page = 1) {
            try {
                let url = `https://api.tixgo.nl/customers?page=${page}&per_page=${this.perPage}`;

                if (this.searchSelected) {
                    url += `&event=${this.searchSelected}`;
                }

                const response = await this.$axios.get(url);

                // Verwacht Laravel pagination structuur
                this.customers = response.data.data;
                this.totalRows = response.data.total;
                this.currentPage = response.data.current_page;

            } catch (error) {
                console.log(error);
            }
        },
        onPageChange(page) {
            this.getCustomers(page);
        }
    },
    created() {
        this.getCustomers();
    }
}
</script>
